import { Box, Typography, Paper, Stack } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import RegenerateReportSection from 'containers/dashboard/singleReportPage/components/RegenerateReportSection'

type Props = {
  message: string
  error: string
  isAdmin?: boolean
  searchId: string
}

export default function ReportError({ message, error, isAdmin, searchId }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        py: 4,
      }}>
      <Paper
        elevation={0}
        sx={{
          p: 6,
          borderRadius: '20px',
          width: '600px',
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
        }}>
        <Stack spacing={3} alignItems="center">
          <ErrorOutlineIcon sx={{ fontSize: 60, color: 'error.main' }} />

          <Typography variant="h6" color="error.main" fontWeight={500}>
            {message}
          </Typography>

          {isAdmin && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                p: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
                width: '100%',
              }}>
              <Box mb={1}>
                <Typography variant="body1" color="text.secondary" fontWeight={'bold'}>
                  Bo admin only
                </Typography>
              </Box>
              <Box mb={2}>
                <Typography variant="body2" color="text.secondary">
                  Error: {error}
                </Typography>
              </Box>

              <RegenerateReportSection searchId={searchId} />
            </Box>
          )}
        </Stack>
      </Paper>
    </Box>
  )
}
